import { usePageTitle } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Layout } from 'components/layout';
const containerIsTabletUpCss = "c18nmo4v";
const containerWithinModalCss = "co3qonc";
const containerOmitOuterBorderCss = "c1v6ltx7";
const containerCss = "c1bp5s9v";
const Container = forwardRef((props, ref) => {
  const {
    withinModal,
    omitOuterBorder,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsTabletUpCss]: isTabletUp,
    [containerWithinModalCss]: withinModal,
    [containerOmitOuterBorderCss]: omitOuterBorder
  }, props.className)} />;
});
const headerWrapperNoDividerCss = "h176n2t9";
const headerWrapperCss = "h3c4msx";
const HeaderWrapper = forwardRef((props, ref) => {
  const {
    omitBottomDivider,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerWrapperCss, {
    [headerWrapperNoDividerCss]: omitBottomDivider
  }, props.className)} />;
});
const HeaderLayout = props => <Layout direction="column" gap="8" grow {...props} />;
const headerIsTabletUpCss = "hoo3hn9";
const headerWithinModalCss = "h1jnz7xy";
const headerCss = "hrpss49";
const Header = forwardRef((props, ref) => {
  const {
    withinModal,
    ...restProps
  } = props;
  const isTabletUp = useDeviceType('isTabletUp');
  return <HeaderLayout ref={ref} {...restProps} className={classNames(headerCss, {
    [headerIsTabletUpCss]: isTabletUp,
    [headerWithinModalCss]: withinModal
  }, props.className)} />;
});
const contentIsTabletUpCss = "c1dfx7li";
const contentWithinModalCss = "cuy5z79";
const contentSectionPaddingLeftCss = "c118tjos";
const contentSectionPaddingRightCss = "cb9snu9";
const contentCss = "crlcw5p";
const Content = forwardRef((props, ref) => {
  const {
    withinModal,
    sectionPaddingLeft,
    sectionPaddingRight,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(contentCss, {
    [contentIsTabletUpCss]: isTabletUp,
    [contentWithinModalCss]: withinModal,
    [contentSectionPaddingLeftCss]: sectionPaddingLeft,
    [contentSectionPaddingRightCss]: sectionPaddingRight
  }, props.className)} />;
});
export const TabPage = forwardRef(({
  pageTitle,
  header,
  withinModal,
  omitOuterBorder = false,
  omitHeader = false,
  omitHeaderDivider = false,
  sectionPaddingLeft,
  sectionPaddingRight,
  children
}, ref) => {
  const availabilityTitle = I18n.t('publisher.personal_settings.availability.title');
  usePageTitle(`${pageTitle} - ${availabilityTitle} - Calendly`);
  return <Container withinModal={withinModal} omitOuterBorder={omitOuterBorder}>
      {!omitHeader ? <HeaderWrapper omitBottomDivider={omitHeaderDivider}>
          <Header withinModal={withinModal}>{header}</Header>
        </HeaderWrapper> : null}
      <Content ref={ref} withinModal={withinModal} sectionPaddingLeft={sectionPaddingLeft} sectionPaddingRight={sectionPaddingRight}>
        {children}
      </Content>
    </Container>;
});

require("./tab_page.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./tab_page.js");